import {BaseComponent} from '../../abstract/base.component';
import { Directive } from "@angular/core";

@Directive()
export abstract class AccessAccountAction extends BaseComponent {
  protected _getRoleList: string;
  protected _assignRoleUrl: string;
  protected abstract passResponse(res);
  protected abstract passError(err);
  protected abstract passAssignResponse(res);
  protected abstract passAssignError(err);

  getAccountList() {
    this.dataManager.getRequest(this._getRoleList, 0)
      .subscribe(
        (res) => this.passResponse(res),
        (err) => {
          this.networkErrorHandler(err);
          this.passError(err);
        }
      );
  }

  assignRoleToUser(body) {
    this.dataManager.postRequest(this._assignRoleUrl, body, 0)
      .subscribe(
        (res) => this.passAssignResponse(res),
        (err) => {
          this.passAssignError(err.error);
          this.networkErrorHandler(err);
        }
      );
  }
}
